import React from 'react';
import { connect } from 'react-redux';
import CreateHighlightMessage from './create-highlight-message';
import NoHighlightsMessage from './no-highlights-message';
import PrivacyMessage from './privacy-message';
import HighlightsProp from 'common/prop-types/highlights';
import HighlightsTab from 'components/shared/profile-tabs/highlights/highlights-tab';
import {
  openDialog,
} from 'common/actions';
import * as DialogTypes from 'common/dialog-types';
import * as HighlightOwnerTypes from 'common/highlight-owner-types';
import ProfileType from 'common/container-subtype';

class TeamHighlightsTab extends React.Component {
  static propTypes = {
    dispatch: React.PropTypes.func,
    forcePublicView: React.PropTypes.bool,
    highlights: HighlightsProp,
    highlightEditorIdentityData: React.PropTypes.shape({
      userId: React.PropTypes.string,
      teamId: React.PropTypes.string,
      isAdmin: React.PropTypes.bool,
      isAthlete: React.PropTypes.bool,
      isCoach: React.PropTypes.bool,
      sport: React.PropTypes.string,
    }),
    team: React.PropTypes.shape({
      hasAnyRoleOnTeam: React.PropTypes.bool,
      highlightsArePrivate: React.PropTypes.bool,
      schoolName: React.PropTypes.string.isRequired,
      teamId: React.PropTypes.string.isRequired,
      teamName: React.PropTypes.string.isRequired,
    }),
    isMobile: React.PropTypes.bool.isRequired,
    user: React.PropTypes.object,
    seoFriendlyName: React.PropTypes.string.isRequired,
    onChangeTab: React.PropTypes.func.isRequired,
  }

  getPrivacyMessage() {
    return (
      <PrivacyMessage dispatch={this.props.dispatch}
        teamId={this.props.team.teamId}
        teamName={this.props.team.teamName}
        onChangeTab={this.props.onChangeTab}
      />
    );
  }

  getCreateHighlightMessage() {
    return (
      <CreateHighlightMessage
        highlightSupportUrl={this.props.highlights.highlightSupportUrl}
        libraryUrl={this.props.highlights.libraryUrl}
      />
    );
  }

  getNoHighlightsMessage() {
    return (
      <NoHighlightsMessage dispatch={this.props.dispatch}
        teamId={this.props.team.teamId}
        teamName={this.props.team.teamName}
        user={this.props.user}
        onChangeTab={this.props.onChangeTab}
      />
    );
  }

  onShareVideoClick(id, title, videoUrl, tweetText) {
    this.props.dispatch(openDialog(
      DialogTypes.SHARE_VIDEO_DIALOG,
      {
        id,
        title,
        tweetText,
        url: videoUrl,
        type: 'Highlight',
      }));
  }

  render() {
    return (
      <HighlightsTab
        profileType={ProfileType.Team}
        dispatch={this.props.dispatch}
        forcePublicView={this.props.forcePublicView}
        highlights={this.props.highlights}
        highlightsArePrivate={this.props.team.highlightsArePrivate}
        highlightEditorIdentityData={this.props.highlightEditorIdentityData}
        ownerType={HighlightOwnerTypes.TEAM}
        ownerId={this.props.team.teamId}
        userCanAccessPrivate={this.props.user.hasAnyRoleOnTeam}
        isPrivilegedUser={this.props.user.isPrivilegedUser}
        isMobile={this.props.isMobile}
        getPrivacyMessage={this.getPrivacyMessage.bind(this)}
        getCreateHighlightMessage={this.getCreateHighlightMessage.bind(this)}
        getNoHighlightsMessage={this.getNoHighlightsMessage.bind(this)}
        onShareVideoClick={this.onShareVideoClick.bind(this)}
        canPinVideos={false}
      />
    );
  }
}

function select(state) {
  return state;
}

export default connect(select)(TeamHighlightsTab);
